import React from 'react';

interface IDividerProps {
  color?: string | null;
  align?: 'left' | 'center' | 'right';
  height?: number | null;
}

interface IShapeProps {
  color?: string | null;
}

export const Shape = (props: IShapeProps) => {
  let { color } = props;
  console.log('prpos', color)
  color = !color ? '#651E38' : color;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="334.547" height="12.214" viewBox="0 0 334.547 12.214">
      <path id="Path_77" data-name="Path 77" d="M2511-3479c11.948,0,11.948,11.214,23.9,11.214S2546.842-3479,2558.789-3479s11.947,11.214,23.894,11.214,11.948-11.214,23.9-11.214,11.948,11.214,23.9,11.214,11.948-11.214,23.9-11.214,11.948,11.214,23.9,11.214,11.948-11.214,23.9-11.214,11.948,11.214,23.9,11.214,11.948-11.214,23.9-11.214,11.948,11.214,23.9,11.214S2785.8-3479,2797.748-3479s11.95,11.214,23.9,11.214,11.95-11.214,23.9-11.214" transform="translate(-2511 3479.5)" fill="none" stroke={color}/>
    </svg>
  );
};

const Divider = (props: IDividerProps) => {
  const { align, height } = props;
  let alignCss;

  switch(align) {
    case 'center':
      alignCss = 'center';
    case 'left':
      alignCss = 'flex-start';
    case 'right':
      alignCss = 'flex-end';
    default: alignCss = 'center'
  }

  const dividerStyle = {
    justifyContent: `${alignCss}`
  }

  return (
    <div 
      className="divider-wrapper"
      style={dividerStyle}
    >
      <Shape color="#651E38" />
    </div>
  );
}

export default Divider;